export default "__VITE_ASSET__jb7jd6Eb__"